/**
 * AddFinancialReportCtrl controller
 * Add/Edit Users Report
 */

import moment from 'moment'
import {
  PAYMENT_SYSTEM_TYPE_NAME,
  PAYMENT_SYSTEM_TYPES, PURCHASE_STATUSES_FOR_FINANCIAL_REPORT, REPORT_FIELDS,
  REPORT_FINANCIAL_PERIODS, REPORT_FINANCIAL_PRODUCT_TYPES,
  SUBSCRIPTION_PLANS_TYPE
} from 'app/core/constants'
import { ascBy, has, lowerCaseProperty } from 'app/helpers/object'
import { getFilteredKeys, multiSelectWithAll } from '../common/directives/contentItems/ciHelpers'
import * as _ from 'lodash-es'

/**
 * AddFinancialReportCtrl controller
 *
 * @class AddFinancialReportCtrl
 * @memberof mwApp/reports
 * @see mwApp/AddFinancialReportCtrl
 *
 * @ngdoc controller
 * @name mwApp/AddFinancialReportCtrl.controller:AddFinancialReportCtrl
 */
/* @ngInject */
export default function AddFinancialReportCtrl (
  $location,
  $scope,
  ReportFinancialSeed,
  alertLiteSvc,
  authSvc,
  commonData,
  extra,
  scope
) {
  const vm = this
  vm.extra = extra
  vm.paymentMethodTypes = []

  /**
   * Product Types
   *
   * @memberof mwApp/packages.controller:AddFinancialReportCtrl
   * @name vm.product_types
   * @type {Object}
   */
  // vm.product_types = PRODUCT_TYPES
  vm.report_financial_product_types = REPORT_FINANCIAL_PRODUCT_TYPES

  if (!authSvc.hasEnabledFlag('FEATURE_PARTNERS_ENABLED')) {
    delete vm.report_financial_product_types.PARTNER_PRODUCT
  }
  if (!authSvc.hasEnabledFlag('FEATURE_MULTI_SETS_ENABLED')) {
    delete vm.report_financial_product_types.MULTI_SET
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  vm.purchase_item_statuses = PURCHASE_STATUSES_FOR_FINANCIAL_REPORT

  vm.reportFields = REPORT_FIELDS
  vm.reportDates = REPORT_FINANCIAL_PERIODS

  /**
   * Listen tab event
   */ // TODO: may be will delete
  $scope.$on('dispatch: users_reports', function () {
    $scope.$broadcast('refreshTable')
  })

  // change reportPeriod list
  $scope.$watch('vm.reportPeriod', (type) => {
    vm.selectReportPeriod(type)
  })

  // reset users if changed packages
  $scope.$watch('vm.report.networks', () => {
    vm.report.users = []
    vm.report.subscriptions = []
  })

  vm.multiSelectWithAll = multiSelectWithAll
  vm.getFilteredKeys = getFilteredKeys

  /**
   * Payment types
   *
   * @memberof mwApp/packages.controller:AddFinancialReportCtrl
   * @type {Object}
   */
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  /**
   * Payment types
   *
   * @memberof mwApp/packages.controller:AddFinancialReportCtrl
   * @type {Object}
   */
  vm.subscription_plans_type = SUBSCRIPTION_PLANS_TYPE

  /**
   * Report state model
   *
   * @memberof mwApp/reports.controller:AddFinancialReportCtrl
   * @type {Object}
   */
  vm.report = new ReportFinancialSeed()

  /**
   * Report types url list
   *
   * @type {Object}
   */
  vm.users_reporting_url = {
    ACTIVATIONS: 'activations'
  }

  /**
   * Report reportPeriod default value
   *
   * @memberof mwApp/reports.controller:AddFinancialReportCtrl
   * @type {String}
   */
  vm.reportPeriod = '2DAYS'

  /**
   * Is Custom period default value
   *
   * @memberof mwApp/reports.controller:AddFinancialReportCtrl
   * @type {Boolean}
   */
  vm.isCustomPeriod = false

  vm.subscriptionsFilter = []

  /**
   * Search users params with default values
   *
   * @memberof mwApp/reports.controller:AddFinancialReportCtrl
   * @type {Object}
   */
  vm.searchUsersParams = {
    searchStr: '',
    networkIds: [],
    page: 0,
    totalPages: 0
  }

  /**
   * Search users params with default values
   *
   * @memberof mwApp/reports.controller:AddFinancialReportCtrl
   * @type {Object}
   */
  vm.searchSubscriptionsParams = {
    searchStr: '',
    networkIds: [],
    page: 0,
    totalPages: 0
  }

  vm.organizationsSelect = {}

  /**
   * Load extra data packages
   */
  ReportFinancialSeed.load(`api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/networks`, {
    networks: []
  }).to(vm.packages = []).then(() => {
    vm.packages.sort(ascBy(lowerCaseProperty('name')))
    vm.packages = [{ id: 'ALL', name: 'All Organizations' }].concat(vm.packages)
  })

  /**
   * Load extra data payment types
   */
  ReportFinancialSeed.load(`api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/paymenttypes`, [])
    .to(vm.paymentSystemTypes = [])
    .then(() => {
      vm.paymentSystemTypes = vm.paymentSystemTypes.filter(p => !['NEWEBPAY', 'TELR'].includes(p))
        .map(type => ({ type, name: vm.payment_system_types[type] }))
    })

  /**
   * Load extra data users
   */
  ReportFinancialSeed.search(
    `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/users`,
    vm.searchUsersParams
  )
    .then((result) => {
      vm.searchUsersParams.totalPages = result.totalPages
      return result.content || []
    })
    .to(vm.users = [])

  /**
   * Load extra data users
   */
  ReportFinancialSeed.search(
    `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/subscriptions`,
    vm.searchSubscriptionsParams
  )
    .then((result) => {
      vm.searchSubscriptionsParams.totalPages = result.totalPages
      return result.content || []
    })
    .to(vm.subscriptionPlans = [])
    .then(() => {
      vm.subscriptionPlans.unshift({
        id: null,
        key: 'CUSTOM_PLANS',
        name: 'Custom Plans'
      })
    })

  /**
   * Select interval by Report Date
   *
   */
  vm.selectReportPeriod = () => {
    const from = new Date()
    const to = new Date()

    vm.report.periodCount = vm.reportDates[vm.reportPeriod].periodCount
    vm.report.periodType = vm.reportDates[vm.reportPeriod].periodType

    if (vm.reportPeriod === 'CUSTOM') {
      vm.report.from = from
      vm.report.to = to
    } else {
      vm.report.from = null
      vm.report.to = null
    }
  }

  // cache default handler for datepicker
  const changeHandlerFrom = (form) => {
    form.dateFrom.$setTouched()
    const fromActual = vm.report.from ? moment(vm.report.from).startOf('day').toDate() : new Date(NaN)
    const toActual = vm.report.to ? moment(vm.report.to).endOf('day').toDate() : new Date(NaN)
    const minError = vm.dpCfgFrom.minDate > fromActual
    const maxError = vm.dpCfgFrom.maxDate < fromActual
    form.dateFrom.$setValidity('min', !minError)
    form.dateFrom.$setValidity('max', !maxError)
    const afterError = toActual < fromActual
    if (afterError) {
      form.dateFrom.$setValidity('after', false)
    } else {
      if (form.dateFrom.$modelValue) {
        form.dateFrom.$setValidity('after', true)
      }
    }
    if (form.dateFrom.$valid) {
      form.dateTo.$setValidity('earlier', true)
    }
  }

  /**
   * Datepicker default settings
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   * @type {{format : string}}
   */
  vm.dpCfgFrom = {
    format: 'dd.MM.yyyy',
    minDate: moment().subtract(0, 'day').startOf('day').subtract(3, 'year').add(1, 'seconds').toDate(),
    maxDate: moment().startOf('day').add(1, 'seconds').toDate(),
    changeHandler: changeHandlerFrom
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   */
  vm.openFrom = function () {
    vm.dpCfgFrom.openedFrom = true
  }

  // cache default handler for datepicker
  const changeHandlerTo = (form) => {
    form.dateTo.$setTouched()
    const fromActual = vm.report.from ? moment(vm.report.from).startOf('day').toDate() : new Date(NaN)
    const toActual = vm.report.to ? moment(vm.report.to).endOf('day').toDate() : new Date(NaN)
    const minError = vm.dpCfgTo.minDate > toActual
    const maxError = vm.dpCfgTo.maxDate < toActual
    form.dateTo.$setValidity('min', !minError)
    form.dateTo.$setValidity('max', !maxError)
    const earlierError = toActual < fromActual
    if (earlierError) {
      form.dateTo.$setValidity('earlier', false)
    } else {
      if (form.dateTo.$modelValue) {
        form.dateTo.$setValidity('earlier', true)
      }
    }
    if (form.dateTo.$valid) {
      form.dateFrom.$setValidity('after', true)
    }
  }

  /**
   * Datepicker default settings
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   * @type {{format : string}}
   */
  vm.dpCfgTo = {
    format: 'dd.MM.yyyy',
    minDate: moment().subtract(1, 'day').endOf('day').subtract(3, 'year').add(1, 'seconds').toDate(),
    maxDate: moment().endOf('day').toDate(),
    changeHandler: changeHandlerTo
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   */
  vm.openTo = function () {
    vm.dpCfgTo.openedTo = true
  }

  /**
   * Generate report
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   */
  vm.generateReport = function () {
    vm.setDisable()
    vm.report
      ._save(null, 'api/report/financial', 'Financial Report generated')
      .data()
      .then(function (response) {
        const id = response.payload.id
        $location.hash('generated_reports')

        commonData.data.update('lastReport', id)

        vm.location.reload()
      })
      .finally(vm.unsetDisable)
  }

  /**
   * Save reports
   *
   * @memberof mwApp/reports.controller:AddUsersReportCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    vm.report
      ._save(() => {}, 'api/report/financial/template')
      .then(function (response) {
        $location.hash('reports_list')

        commonData.data.update('lastTemplate', has('payload')(response.data)
          ? response.data.payload.id
          : response.data.id)

        vm.location.reload()
      })
      .finally(vm.unsetDisable)
  }

  /**
   * Change Subscription Plans
   */
  vm.changeSubscription = function () {
    vm.report.subscriptionsFilter.names = []
    vm.report.subscriptionsFilter.dailySubscriptionLength = null
    vm.report.subscriptionsFilter.monthlySubscriptionLength = null
    // vm.report.availableAllSubscriptions = true
    // vm.report.includeCustomSubscriptions = false
  }

  /**
   * Filter users, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddUsersReportCtrl
   * @param  {Object} $select
   */
  vm.$timerUsers = 0
  vm.openCountUsers = 0
  vm.refreshUsers = function ($select = {}) {
    let search = $select.search || ''

    vm.searchUsersParams.page = 0

    search = search ? search.toLowerCase() : ''
    vm.openCountUsers = $select.open ? vm.openCountUsers + 1 : 0

    if (vm.openCountUsers > 1) {
      vm.searchUsersParams.searchStr = $select.search
    }

    if (vm.openCountUsers === 1) {
      $select.search = vm.searchUsersParams.searchStr
    }

    if ($select.open) {
      window.clearTimeout(vm.$timerUsers)
      vm.$timerUsers = window.setTimeout(() => {
        ReportFinancialSeed.search(
          `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/users`,
          {
            searchStr: search,
            page: 0,
            networkIds: vm.report.networks // .map((n) => n.id).filter(n => n !== null)
          }
        )
          .then((result) => {
            vm.searchUsersParams.totalPages = result.totalPages
            vm.users = result.content || []
          })
      }, 700)
    }
  }

  /**
   * Tag transformer for custom select value
   *
   * @param newTag
   * @return {{id : null, email : *}}
   */
  vm.tagTransform = function (newTag) {
    return {
      id: null,
      email: newTag
    }
  }

  /**
   * Filter subscriptions, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddUsersReportCtrl
   * @param  {Object} $select
   */
  vm.$timerSubscriptions = 0
  vm.openCountSubscriptions = 0
  vm.refreshSubscriptions = function ($select = {}) {
    let search = $select.search || ''

    vm.searchSubscriptionsParams.page = 0

    search = search ? search.toLowerCase() : ''
    vm.openCountSubscriptions = $select.open
      ? vm.openCountSubscriptions + 1
      : 0

    if (vm.openCountSubscriptions > 1) {
      vm.searchSubscriptionsParams.searchStr = $select.search
    }

    if (vm.openCountSubscriptions === 1) {
      $select.search = vm.searchSubscriptionsParams.searchStr
    }

    if ($select.open) {
      window.clearTimeout(vm.$timerSubscriptions)
      vm.$timerSubscriptions = window.setTimeout(() => {
        ReportFinancialSeed.search(
          `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/subscriptions`,
          {
            searchStr: search,
            page: 0,
            networkIds: vm.report.networks.map((n) => n.id)
          }
        )
          .then((result) => {
            vm.searchSubscriptionsParams.totalPages = result.totalPages
            vm.subscriptionPlans = result.content || []
            vm.subscriptionPlans.unshift({
              id: null,
              key: 'CUSTOM_PLANS',
              name: 'Custom Plans'
            })
          })
      }, 700)
    }
  }

  /**
   * Callback for Select subscriptions item
   *
   */
  vm.onSelectedSubscription = function () {
    vm.report.includeCustomSubscriptions = !!vm.report.subscriptions.find((s) => !s.id)
  }

  /**
   * Callback for remove subscriptions item
   */
  vm.onRemoveSubscription = function () {
    vm.report.includeCustomSubscriptions = !!vm.report.subscriptions.find((s) => !s.id)
    if (!vm.report.subscriptions.length) {
      vm.report.includeCustomSubscriptions = true
    }
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerUsersScroll = 0
  vm.usersCallbackScroll = (event) => {
    const { page, totalPages } = vm.searchUsersParams
    if (page <= totalPages && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerUsersScroll)
      vm.$timerUsersScroll = window.setTimeout(() => {
        ReportFinancialSeed.search(
          `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/users`,
          { ...vm.searchUsersParams, page: page + 1 }
        )
          .then((result) => {
            vm.users = vm.users.concat(result.content)
            vm.searchUsersParams.page = result.number
          })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerSubscriptionsScroll = 0
  vm.subscriptionsCallbackScroll = (event) => {
    const { page, totalPages } = vm.searchSubscriptionsParams
    if (page <= totalPages && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerSubscriptionsScroll)
      vm.$timerSubscriptionsScroll = window.setTimeout(() => {
        ReportFinancialSeed.search(
          `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/subscriptions`,
          { ...vm.searchSubscriptionsParams, page: page + 1 }
        )
          .then((result) => {
            vm.subscriptionPlans = vm.subscriptionPlans.concat(result.content)
            vm.searchSubscriptionsParams.page = result.number
          })
      }, 700)
    }
  }

  // $scope.$watch('vm.report.networks', () => {
  //   if (vm.report.networks.length > 1 && vm.report.networks.find(n => n.id === null)) {
  //     vm.report.networks = vm.report.networks.filter(n => n.id === null)
  //   }
  // })

  vm.displayPaymentsToggles = function (types, field) {
    const result = !vm.report.purchaseItemCategories.length ||
      vm.report.purchaseItemCategories.some(item => types.includes(item))

    if (!result && field) vm.report[field] = null
    return result
  }

  vm.subscriptionsFilter = [].concat(scope.subscriptions)
  vm.subscriptionsFilterIds = []

  vm.loadSubscriptions = function () {
    const networkIds = vm.report.organizations.map(i => i.id).join(',')

    return ReportFinancialSeed.loadExtra({ params: { networkIds } })
      .then(data => data.subscriptions)
      .then(subscriptions => {
        vm.subscriptionsFilter.length = 0
        vm.subscriptionsFilter = [].concat(subscriptions)
        vm.subscriptionsFilterNames = vm.subscriptionsFilter.map(i => i.name)
        vm.filterSubscriptions()
      })
      .catch(rejection => alertLiteSvc.alertError(rejection))
      .finally(vm.unsetDisable)
  }
  vm.filterSubscriptions = function () {
    vm.report.subscriptionsFilter.names = vm.report.subscriptionsFilter.names?.filter(name => vm.subscriptionsFilterNames.includes(name))
  }

  vm.getOrganizationsDebounced = _.debounce(vm.loadSubscriptions, 1500)

  vm.onOrganizationsChange = function () {
    vm.multiSelectWithAll(vm.report.organizations, vm.organizationsSelect)
    vm.setDisable()
    vm.getOrganizationsDebounced()
  }

  vm.deselectOrganizations = function () {
    vm.setDisable()
    vm.getOrganizationsDebounced()
  }

  vm.organizationsSelect.val = { id: 'ALL', name: 'All Organizations' }

  vm.onDestroyAllSubscriptions = function () {
    if (vm.report.subscriptionsFilter.names) vm.report.subscriptionsFilter.names.length = 0
  }

  vm.onDestroySubscriptionLength = function () {
    delete vm.report.subscriptionsFilter.monthlySubscriptionLength
    delete vm.report.subscriptionsFilter.dailySubscriptionLength
  }

  vm.onPaymentSystemTypesChange = function () {
    const arr = []
    vm.report.paymentSystemTypes.forEach(type => (arr.push(...extra.paymentSystem2PaymentMethods[type])))
    vm.paymentMethodTypes = arr.filter((it, index) => index === arr.indexOf(it = it.trim()))
    vm.report.paymentMethodTypes = vm.report.paymentMethodTypes.filter(i => vm.paymentMethodTypes.includes(i))
  }

  vm.paymentSystemTypeName = PAYMENT_SYSTEM_TYPE_NAME
}
